module.exports = __webpack_public_path__ + "static/media/web-app3.fe353dd8.jpg";